import script from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"

import "./ButtonApp.vue?vue&type=style&index=0&id=51e21b78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e21b78"]])

export default __exports__